function fetchSection(sectionId) {
  const sectionUrl = `${window.location.pathname}/?section_id=${sectionId}`;

  fetch(sectionUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionContent = doc.querySelector(`#shopify-section-${sectionId}`);
      document.querySelector(`#shopify-section-${sectionId}`).innerHTML = sectionContent.innerHTML;
      $('body').removeClass('overflow-hidden');
      if ($('.product-card-wrapper').length > 0) {
      $('.product-card-wrapper').each(function () {
        var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
          slidesPerView: 1,
          spaceBetween: 7,
          initialSlide: $(this).find('.product-card-media-img.active').length ? $(this).find('.product-card-media-img.active').index() : 0,
          loop: true,
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: $(this).find('.product-card-media-slider .swiper-button-next')[0],
            prevEl: $(this).find('.product-card-media-slider .swiper-button-prev')[0],
          },
          pagination: {
            el: $(this).find('.product-card-media-slider .swiper-pagination')[0],
            clickable: true,
          },
          nested: true
        });
      });
    }
    })
    .catch((error) => {
      console.error('Error fetching section:', error);
    });
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle) {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    var header_height = document.querySelector('.section-header .header-wrapper');
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(header_height.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    if(document.querySelector('#header-group-wrap')){
      document.querySelector('#header-group-wrap').classList.add('menu-open');
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    if(document.querySelector('#header-group-wrap')){
      document.querySelector('#header-group-wrap').classList.remove('menu-open');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        var related_product = new Swiper('.related-products .related-products-row',{
          slidesPerView: 'auto',
          spaceBetween: 5,
          loop: true,
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: '.related-products .swiper-action-bar .swiper-button-next',
            prevEl: '.related-products .swiper-action-bar .swiper-button-prev',
          },
          breakpoints: {
            750: {
              spaceBetween: 7
            }
          }
        });

        $('.related-products .product-card-wrapper').each(function () {
          var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
            slidesPerView: 1,
            spaceBetween: 7,
            initialSlide: $(this).find('.product-card-media-img.active').length ? $(this).find('.product-card-media-img.active').index() - 1 : 0,
            loop: true,
            allowTouchMove: false,
            navigation: {
              nextEl: $(this).find('.product-card-media-slider .swiper-button-next')[0],
              prevEl: $(this).find('.product-card-media-slider .swiper-button-prev')[0],
            },
            nested: true
          });
        });

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        if (html.querySelector('.related-product-block')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  theme.BannerSlideshow = (function() {
    function BannerSlideshow(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.main-banner .main-banner-slider');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    BannerSlideshow.prototype = Object.assign({}, BannerSlideshow.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');

        function main_banner_height(){
          var header = $('#header-group-wrap').outerHeight();
          $('.main-banner').css('--banner-height',($(window).height() - header + 'px'));
        }
        main_banner_height();
        $(window).on('resize',function(){
          main_banner_height();
        });
  
        // this.slideshow.classList.remove('loading', 'loading--delayed');
        // this.slideshow.classList.add('loaded');

        function assignUniqueClass(swiper) {
          let cloneCount = {};
      
          swiper.slides.each(function () {
            let $slide = $(this);
    
            let originalClass = $slide[0].classList.value.split(' ').find(cls => cls.startsWith('swiper-slide--'));
            if (!originalClass) return;
    
            if ($slide.hasClass('swiper-slide-duplicate')) {
              cloneCount[originalClass] = (cloneCount[originalClass] || 0) + 1;
              let newClass = `${originalClass}-${cloneCount[originalClass]}`;
              $slide.removeClass(originalClass).addClass(newClass);
            }
          });
        }

        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            loop: true,
            mousewheel: {
              forceToAxis: true
            },
            navigation: {
              nextEl: '.main-banner .swiper-button-next',
              prevEl: '.main-banner .swiper-button-prev',
            },
            breakpoints: {
              750: {
                  speed: 2000,
              }
            },
            on: {
              init: function () {
                assignUniqueClass(this);
              },
              slideChange: function () {
                assignUniqueClass(this);
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt($(slide).index());
        
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return BannerSlideshow;
  })();

  theme.featuredCollection = (function() {
    function featuredCollection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.featured-collection .featured-collection-slider');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    featuredCollection.prototype = Object.assign({}, featuredCollection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 'auto',
            spaceBetween: 5,
            loop: true,
            mousewheel: {
              forceToAxis: true
            },
            navigation: {
              nextEl: '.featured-collection .featured-collection-arrow-next',
              prevEl: '.featured-collection .featured-collection-arrow-prev',
            },
            breakpoints: {
              750: {
                  spaceBetween: 7
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      }
    });
  
    return featuredCollection;
  })();

  theme.infiniteProducts = (function() {
    function infiniteProducts(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.products-infinite-scroll-bar-one');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    infiniteProducts.prototype = Object.assign({}, infiniteProducts.prototype, {
      init: function() {
        var speed = parseInt($(this.container).attr('data-desktop-speed'));
        if ($(window).width() < 750) {
          speed = parseInt($(this.container).attr('data-mobile-speed'));
        }
        $(this.container).find('.products-infinite-scroll-bar-one').marquee({
          speed: speed * 1000,
          gap: 0,
          delayBeforeStart: 0,
          direction: 'left',
          duplicated: true,
          pauseOnHover: true
        });
        $(this.container).find('.products-infinite-scroll-bar-two').marquee({
          speed: speed * 1000,
          gap: 0,
          delayBeforeStart: 0,
          direction: 'right',
          duplicated: true,
          pauseOnHover: true
        });
      },
    });
  
    return infiniteProducts;
  })();

  theme.multiColumnSlider = (function() {
    function multiColumnSlider(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.multicolumn-slider .multicolumn-slider-wrap');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    multiColumnSlider.prototype = Object.assign({}, multiColumnSlider.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 'auto',
            spaceBetween: 7,
            loop: false,
            freeMode: true,
            mousewheel: {
              forceToAxis: true
            },
            navigation: {
              nextEl: '.multicolumn-slider .swiper-button-next',
              prevEl: '.multicolumn-slider .swiper-button-prev',
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return multiColumnSlider;
  })();

  theme.pressIconBar = (function() {
    function pressIconBar(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.press-icon-bar .marquee');
      if (!this.slideshow) { return }
      
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    pressIconBar.prototype = Object.assign({}, pressIconBar.prototype, {
      init: function() {
        var speed = parseInt($(this.container).attr('data-desktop-speed'));
        if ($(window).width() < 750) {
          speed = parseInt($(this.container).attr('data-mobile-speed'));
        }
        $(this.container).find('.marquee').marquee({
          gap: 0,
          speed: speed * 1000,
          duplicated: true
        });
      },
    });
  
    return pressIconBar;
  })();

  theme.shopTheLook = (function() {
    function shopTheLook(container) {
        this.container = container;
        var sectionId = container.getAttribute('data-section-id');
        this.slideshow = container.querySelector('.shop-the-look-products-row'); // Corrected selector for Swiper container
        if (!this.slideshow) { return }

        var sectionEl = this.container; // In your original Liquid, 'container' is the section element
        var sectionParent = sectionEl.parentElement;
        var sectionIndex = sectionParent ? [].indexOf.call(sectionParent.children, sectionEl) : -1;

        if (sectionIndex === 0) { // Or some other condition for immediate init
            this.init();
        } else {
            // Ensure theme.initWhenVisible is robust or consider always initing if element is present
            if (typeof theme.initWhenVisible === 'function') {
                theme.initWhenVisible({
                    element: this.container,
                    callback: this.init.bind(this)
                });
            } else {
                // Fallback if initWhenVisible is not available, init directly
                this.init();
            }
        }
    }

    shopTheLook.prototype = Object.assign({}, shopTheLook.prototype, {
        init: function() {
            var slides = this.slideshow.querySelectorAll('.swiper-slide');
            var _this = this; // Reference to shopTheLook instance

            if (slides.length === 0) {
                return; // No slides, nothing to initialize
            }

            if (slides.length > 1) {
                this.swiper = new Swiper(this.slideshow, {
                    slidesPerView: 1,
                    spaceBetween: 7,
                    loop: true,
                    mousewheel: {
                        forceToAxis: true
                    },
                    navigation: {
                        // Scoped to the current slideshow container
                        nextEl: this.slideshow.querySelector('.swiper-button-next'),
                        prevEl: this.slideshow.querySelector('.swiper-button-prev'),
                    },
                    on: {
                        slideChangeTransitionEnd: function () {
                            // 'this' inside Swiper events is the Swiper instance.
                            // Call updateActiveIndicator on the shopTheLook instance (_this)
                            if (typeof _this.updateActiveIndicator === 'function') {
                                _this.updateActiveIndicator();
                            }
                        },
                        init: function () { // For initial active indicator
                            if (typeof _this.updateActiveIndicator === 'function') {
                                _this.updateActiveIndicator();
                            }
                        }
                    }
                });
            } else {
                // Only one slide, Swiper won't initialize.
                // Add 'active' class to the slide and corresponding indicator manually.
                if (slides[0]) {
                    slides[0].classList.add('swiper-slide-active');
                }
                this.updateActiveIndicator(); // Call to set initial indicator active state
            }

            // Indicator click/mouseenter handling, scoped to the current container
            $(this.container).find('.shop-the-look-indicator').off('click mouseenter').on('click mouseenter', function (e) {
                if (e.type === 'click') {
                    e.preventDefault();
                }

                if (!_this.swiper && slides.length === 1) { // Only one slide, Swiper not initialized
                    // Manually update active indicator if needed (though updateActiveIndicator should handle this)
                    $( _this.container).find('.shop-the-look-indicator').removeClass('js-active-indicator');
                    $(this).addClass('js-active-indicator'); // 'this' is the clicked/hovered indicator
                    return;
                }
                if (!_this.swiper) return; // No Swiper instance to control

                var originalBlockIndex = $(this).data('target-index').toString();
                var targetSwiperRealIndex = -1;

                for (const slide of _this.swiper.slides) {
                    if (slide.dataset.index === originalBlockIndex && slide.hasAttribute('data-swiper-slide-index')) {
                        targetSwiperRealIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
                        break;
                    }
                }

                if (targetSwiperRealIndex !== -1) {
                    _this.swiper.slideToLoop(targetSwiperRealIndex, 300); // Use a reasonable speed
                } else {
                    console.warn('ShopTheLook (ID: ' + _this.container.dataset.sectionId + '): Could not find matching Swiper slide for indicator index: ' + originalBlockIndex);
                }

                if (e.type === 'click' && $(window).width() < 750) {
                    var shop_the_look_scroll = $(this).closest('.shop-the-look').find('.shop-the-look-main').offset().top - 150;
                    window.scrollTo({ top: shop_the_look_scroll, behavior: "smooth" });
                }
            });
        },

        updateActiveIndicator: function() {
            const indicators = $(this.container).find('.shop-the-look-indicator');
            indicators.removeClass('js-active-indicator'); // Your active class

            let activeOriginalBlockIndex = null;

            if (this.swiper && typeof this.swiper.realIndex !== 'undefined') { // Swiper is initialized
                const currentSwiperRealIndex = this.swiper.realIndex;
                for (const slide of this.swiper.slides) {
                    if (slide.hasAttribute('data-swiper-slide-index') && parseInt(slide.dataset.swiperSlideIndex, 10) === currentSwiperRealIndex) {
                        if (slide.hasAttribute('data-index')) {
                            activeOriginalBlockIndex = slide.dataset.index;
                            break;
                        }
                    }
                }
            } else if (this.slideshow.querySelectorAll('.swiper-slide').length === 1) { // Single slide, no Swiper
                 const singleSlide = this.slideshow.querySelector('.swiper-slide');
                 if (singleSlide && singleSlide.hasAttribute('data-index')) {
                    activeOriginalBlockIndex = singleSlide.dataset.index;
                 }
            }


            if (activeOriginalBlockIndex !== null) {
                indicators.filter('[data-target-index="' + activeOriginalBlockIndex + '"]').addClass('js-active-indicator');
            }
        },

        onBlockSelect: function(evt) { // For Shopify Theme Editor
            if (!this.slideshow) return;
            var slideElement = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId);

            if (!slideElement) {
                console.warn('ShopTheLook (ID: ' + this.container.dataset.sectionId + '): onBlockSelect - slide not found for blockId: ' + evt.detail.blockId);
                return;
            }

            var targetSwiperRealIndex = -1;

            // Try to get the data-swiper-slide-index directly if Swiper has processed the slide
            if (slideElement.hasAttribute('data-swiper-slide-index')) {
                targetSwiperRealIndex = parseInt(slideElement.dataset.swiperSlideIndex, 10);
            } else if (slideElement.hasAttribute('data-index') && this.swiper && this.swiper.slides) {
                // Fallback: If data-swiper-slide-index isn't on the element directly (e.g. before swiper init fully processed it)
                // Find it by iterating through swiper's known slides using the original data-index
                const originalBlockIndexForSelected = slideElement.dataset.index;
                for (const s of this.swiper.slides) {
                    if (s.dataset.index === originalBlockIndexForSelected && s.hasAttribute('data-swiper-slide-index')) {
                        targetSwiperRealIndex = parseInt(s.dataset.swiperSlideIndex, 10);
                        break;
                    }
                }
            }


            if (this.swiper) {
                if (targetSwiperRealIndex !== -1) {
                    this.swiper.slideToLoop(targetSwiperRealIndex, 0); // Speed 0 for instant jump in editor
                } else {
                    // If real index cannot be determined, attempt with original data-index (less reliable for loop)
                    const originalIndex = parseInt(slideElement.dataset.index, 10);
                    this.swiper.slideToLoop(originalIndex, 0);
                    console.warn('ShopTheLook (ID: ' + this.container.dataset.sectionId + '): onBlockSelect - used fallback original index for blockId: ' + evt.detail.blockId);
                }
                if (this.swiper.autoplay && typeof this.swiper.autoplay.pause === 'function') {
                    this.swiper.autoplay.pause();
                }
            } else {
                // Swiper not initialized yet, store intended index (original data-index)
                if (slideElement.hasAttribute('data-index')) {
                    this.initialIndex = parseInt(slideElement.dataset.index, 10);
                    // This initialIndex would ideally be used by Swiper's `initialSlide` option.
                    // Requires mapping this `forloop.index0` value to a "real" Swiper index *before* Swiper init.
                    // For now, this just sets a property. The Swiper init config doesn't use it yet.
                }
                // Original timeout logic (might need adjustment if Swiper init is robust)
                setTimeout(function() {
                    if (this.swiper && this.swiper.autoplay && typeof this.swiper.autoplay.pause === 'function') {
                        this.swiper.autoplay.pause();
                    }
                }.bind(this), 1000);
            }
        },

        // Keep other methods like forceReload, onUnload, onDeselect, onBlockDeselect
        // as they were, unless they also need adjustments for slide indexing.
        forceReload: function() {
            this.onUnload();
            this.init();
        },

        onUnload: function() {
            if (this.swiper && typeof this.swiper.destroy === 'function') {
                this.swiper.destroy(true, true); // Destroy Swiper instance and remove listeners
                this.swiper = null; // Clear the reference
            }
        },

        onDeselect: function() { // Example: May need to re-init or ensure state
            // If Swiper was destroyed, onDeselect might not have a 'this.swiper'
            // This logic seems to try to re-init if it was paused.
            // Consider if a full re-init might be needed depending on theme editor interaction.
             if (this.swiper && this.swiper.initialized && this.swiper.params.autoplay && this.swiper.params.autoplay.enabled) {
                 if(typeof this.swiper.autoplay.start === 'function') {
                    this.swiper.autoplay.start();
                 }
             }
        },

        onBlockDeselect: function() {
            if (this.swiper && this.swiper.params.autoplay && this.swiper.params.autoplay.enabled) {
                if (typeof this.swiper.autoplay.start === 'function') {
                    this.swiper.autoplay.start();
                }
            }
        }
    });

    return shopTheLook;
  })();

  theme.infiniteTextBar = (function() {
    function infiniteTextBar(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.infinite-text-bar .marquee');
      if (!this.slideshow) { return }
      
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    infiniteTextBar.prototype = Object.assign({}, infiniteTextBar.prototype, {
      init: function() {
        var speed = parseInt($(this.container).attr('data-desktop-speed'));
        if ($(window).width() < 750) {
          speed = parseInt($(this.container).attr('data-mobile-speed'));
        }
        $(this.container).find('.marquee').marquee({
          gap: 0,
          speed: speed * 1000,
          direction: 'left',
          duplicated: true
        });
      },
    });
  
    return infiniteTextBar;
  })();

  theme.RecentlyView = (function() {
    function RecentlyView(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.recently-view-products .recently-view-products-row');
      // if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      this.init();
  
    }
  
    RecentlyView.prototype = Object.assign({}, RecentlyView.prototype, {
      init: function() {
        var _this = this;
        var notNull = productHandleQueue.filter(item => item);
        productHandleQueue = productHandleQueue.filter(item => item && item !== window.cProductHandle);
        if (productHandleQueue.length > 0 && productHandleQueue[0] != '') {
          $(this.container).show();
          var count = 0;
          $(productHandleQueue).each(function(i, v) {
            if (i <= 10 && v != '') {
              var hh = i;
              count++;
              jQuery.ajax({
                dataType: 'html',
                url: '/products/' + productHandleQueue[i] + '?view=card',
                cache: false,
                success: function(data) {
                  var html = '';
                  html += '<div class="recently-view-product-block swiper-slide">',
                  html += data
                  html += '</div>'
                  $('.recently-view-products .recently-pro').append(html);
                  if (productHandleQueue.length == count) {
                    $('.recently-view-products .product-card-wrapper').each(function () {
                      var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
                        slidesPerView: 1,
                        spaceBetween: 7,
                        initialSlide: $(this).find('.product-card-media-img.active').length ? $(this).find('.product-card-media-img.active').index() : 0,
                        loop: true,
                        allowTouchMove: false,
                        navigation: {
                          nextEl: $(this).find('.product-card-media-slider .swiper-button-next')[0],
                          prevEl: $(this).find('.product-card-media-slider .swiper-button-prev')[0],
                        },
                        nested: true
                      });
                    });
                  }
                  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                },
                error: function() {
                  cookie.remove(productHandleQueue[i]);
                }
              });
            }
          });
          setTimeout(function() {
            _this.swiper = new Swiper(_this.slideshow, {
              slidesPerView: 'auto',
              spaceBetween: 5,
              // loop: true,
              mousewheel: {
                forceToAxis: true
              },
              navigation: {
                nextEl: '.recently-view-products .swiper-action-bar .swiper-button-next',
                prevEl: '.recently-view-products .swiper-action-bar .swiper-button-prev',
              },
              breakpoints: {
                750: {
                  spaceBetween: 7
                }
              }
            });
          }, 1000);
        } else {
          $(this.container).hide();
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return RecentlyView;
  })();

  theme.imageGallery = (function() {
    function imageGallery(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.image-gallery .image-gallery-row');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    imageGallery.prototype = Object.assign({}, imageGallery.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 'auto',
            spaceBetween: 5,
            loop: true,
            speed: 600,
            freeMode: true,
            mousewheel: {
              forceToAxis: true
            },
            navigation: {
              nextEl: '.image-gallery .swiper-button-next',
              prevEl: '.image-gallery .swiper-button-prev',
            },
            breakpoints: {
              750: {
                  spaceBetween: 7
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      }
    });
  
    return imageGallery;
  })();

  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }
  DOMready(function(){
    theme.sections = new theme.Sections();
  
    theme.sections.register('main-banner', theme.BannerSlideshow);
    theme.sections.register('featured-collection', theme.featuredCollection);
    theme.sections.register('products-infinite-scroll', theme.infiniteProducts);
    theme.sections.register('multicolumn-slider', theme.multiColumnSlider);
    theme.sections.register('press-icon-bar', theme.pressIconBar);
    theme.sections.register('shop-the-look', theme.shopTheLook);
    theme.sections.register('infinite-text-bar', theme.infiniteTextBar);
    theme.sections.register('recently-view-products', theme.RecentlyView);
    theme.sections.register('image-gallery', theme.imageGallery);
  });
})();

$(document).ready(function() {

  // Define action constants
  const ADD = "ADD";
  const CHANGE = "CHANGE";
  const UPDATE = "UPDATE";
  const CART = "CART";
  const CART_HTML = "CART_HTML";
  const CART_DRAWER_HTML = "CART_DRAWER_HTML";
  
  // Define function to interact with the server
  const performServerAction = async function(data, action = ADD) {
      let url = "/cart/add.js";
      let method = action.includes("CART") ? "GET" : "POST";
  
      if (action === CHANGE) url = "/cart/change.js";
      if (action === UPDATE) url = "/cart/update.js";
      if (action === CART) url = "/cart.js";
      if (action === CART_HTML) url = "/cart";
      if (action === CART_DRAWER_HTML) url = window.location.pathname;
  
      try {
          // Perform fetch request
          const response = await fetch(url, {
              method: method,
              credentials: "same-origin",
              headers: {
                  "Content-Type": action.includes("HTML") ? "text/html" : "application/json",
                  "X-Requested-With": "xmlhttprequest",
                  "Cache-Control": "no-cache, no-store, must-revalidate",
                  Pragma: "no-cache",
                  Expires: 0
              },
              body: data && JSON.stringify(data)
          });
  
          // Parse response
          const responseData = await (action.includes("HTML") ? response.text() : response.json());
  
          // Handle response
          if (responseData.status) {
              throw new Error(responseData.description);
          }
  
          return responseData;
      } catch (error) {
          console.error(error);
      }
  };
  
  // Define function to add items to the cart
  const addItemToCart = async function(itemId, qty = 1, redirectToCart = true) {
    const item = {
      id: itemId,
      quantity: qty
    };
  
    try {
      const response = await performServerAction(item);
      if (!response) return;
      if (redirectToCart) {
        window.location.href = "/cart";
      } else {
        if (window.location.href.indexOf('/cart') > -1) {
          updateCart();
        } else {
          updateCartDrawer();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to remove pack from cart
  const removePackFromCart = async function(packId, removeFromCart = true) {
    const response = await getCartState();
    if (!response) return;
    const items = response.items.reduce((accumulator, currentItem) => {
      const key = currentItem.key;
      const properties = currentItem.properties;
      if (properties && properties.packId === parseInt(packId, 10)) {
        accumulator[key] = 0;
      }
      return accumulator;
    }, {});
  
    if (Object.keys(items).length) {
      await updateCartItems(items, removeFromCart);
    }
  };
  
  // Define function to add multiple items to cart
  const addItemsToCart = async function(items, redirectToCart = true) {
    try {
      const response = await performServerAction({ items: items });
      if (!response) return;
      // if (window.location.href.indexOf('/cart') > -1) {
      //   updateCart();
      // } else {
      //   updateCartDrawer();
      // }
      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart items
  const updateCartItems = async function(updates, redirectToCart = true) {
    try {
      const response = await performServerAction({ updates: updates }, UPDATE);
      if (!response) return;
      if (window.location.href.indexOf('/cart') > -1) {
        updateCart();
      } else {
        updateCartDrawer();
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  const updateCartSingleItems = async function(id, quantity) {
    try {
      const dataToSend = {
        id: id,
        quantity: quantity
      };
      const response = await performServerAction(dataToSend, CHANGE);
      if (!response) {
        return;
      }
      if (window.location.href.indexOf('/cart') > -1) {
        updateCart();
      } else {
        updateCartDrawer();
      }
    } catch (error) {
        console.error(error);
    }
  }
  
  
  // Define function to get cart state
  const getCartState = async function() {
    try {
      const cartData = await performServerAction(null, CART);
      if (!cartData) return;
      return cartData;
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart item count
  const updateCartItemCount = function(count) {
    const cartItemCountElement = document.querySelector(".cart-count-bubble span:first-child");
    if (cartItemCountElement) {
      cartItemCountElement.innerHTML = count || 0;
    }
  };
  
  // Define function to disable/enable cart submit button
  const disableCartSubmitButton = function(disabled) {
    const cartSubmitButton = document.querySelector("[data-cart-submit]");
    if (cartSubmitButton) {
      cartSubmitButton.toggleAttribute("disabled", disabled);
    }
  };
  
  // Define function to update cart submit button
  const updateCartSubmitButton = function(totalPrice) {
    disableCartSubmitButton(true);
  };
  
  const updateCartState = async function() {
    try {
      const response = await getCartState();
      if (!response) return;
      updateCartSubmitButton(response.total_price);
      updateGiftBars(response.total_price);
      return response;
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart
  const updateCart = async function(forceUpdate) {
    const cartContentElement = document.querySelector("[data-cart-content]");
    let updateCart = forceUpdate;
    if (!updateCart) updateCart = await updateCartState();
    await addRemoveGiftsFromCart(updateCart.total_price);
    await performServerAction(null, CART_HTML).then(cartHtml => {
      if (!cartHtml) return;
  
      const parser = new window.DOMParser();
      const cartHtmlDoc = parser.parseFromString(cartHtml, "text/html");
      const newCartContent = cartHtmlDoc.querySelector("[data-cart-content]");
      const cartQuantityElement = cartHtmlDoc.querySelector(".cart-count-bubble span:first-child");
  
      if (cartContentElement) {
        cartContentElement.innerHTML = newCartContent.innerHTML;
        cartContentElement.setAttribute("data-line-item-count", newCartContent.getAttribute("data-line-item-count"));
      }
  
      if (cartQuantityElement) {
        updateCartItemCount(cartQuantityElement.innerHTML);
      }
    }).catch(error => console.error(error));
  };

    window.updateCart= updateCart;
  
  // Define function to update cart
  const updateCartDrawer = async function(forceUpdate) {
    const cartDrawerContentElement = document.querySelector("cart-drawer");
    var updateCart = await updateCartState();
    await addRemoveGiftsFromCart(updateCart.total_price);
    await performServerAction(null, CART_DRAWER_HTML).then(cartHtml => {
      if (!cartHtml) return;
  
      const parserDrawer = new window.DOMParser();
      const cartHtmlDocDrawer = parserDrawer.parseFromString(cartHtml, "text/html");
      const newCartContentDrawer = cartHtmlDocDrawer.querySelector("cart-drawer");
      const cartQuantityElementDrawer = cartHtmlDocDrawer.querySelector(".cart-count-bubble span:first-child");
  
      if (cartDrawerContentElement) {
        cartDrawerContentElement.innerHTML = newCartContentDrawer.innerHTML;
        if (cartDrawerContentElement && cartDrawerContentElement.classList.contains('is-empty')) cartDrawerContentElement.classList.remove('is-empty');
        cartDrawerContentElement.querySelector('#CartDrawer-Overlay').addEventListener('click', cartDrawerContentElement.close.bind(cartDrawerContentElement));
      }
  
      if (cartQuantityElementDrawer) {
        updateCartItemCount(cartQuantityElementDrawer.innerHTML);
      }
  
      if (updateCart.item_count == 0) {
        cartDrawerContentElement.classList.add('is-empty')
      }
  
      document.querySelector('cart-drawer').open();
      
    }).catch(error => console.error(error));
  };

  window.updateCartDrawer= updateCartDrawer;
  
  function updateOption(avi, form, selectorIndex) {
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = form.find('[data-option]:eq(0)');
        break;
      case 1:
        var key = form.find('[data-option]:eq(0) a.current').attr('data-value') || form.find('[data-option]:eq(0) a.default').attr('data-value');
        var selector = form.find('[data-option]:eq(1)');
        break;
      case 2:
        var key = form.find('[data-option]:eq(0) a.current').attr('data-value') || form.find('[data-option]:eq(0) a.default').attr('data-value');
        key += ' / ' + form.find('[data-option]:eq(1) a.current').attr('data-value') || form.find('[data-option]:eq(1) a.default').attr('data-value');
        var selector = form.find('[data-option]:eq(2)');
    }

    // var initialValue = selector.find('input[type="radio"]:checked').val();
    var availableOptions = avi[key];
    if (typeof availableOptions !== "undefined") {
      form.find('[data-option][data-option-index="' + selectorIndex + '"] a').each(function() {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
          $(this).removeClass('disabled');
        } else {
          $(this).addClass('disabled');
        }
      });
    } else {
      form.find('[data-option][data-option-index="' + selectorIndex + '"] a').each(function() {
        $(this).addClass('disabled');
      });
    }
    // if (selector.find('input[value="'+initialValue+'"]').parent().hasClass('soldout')) {
    //   selector.find('li:not(.soldout):eq(0) input').trigger('click');
    // } else {
    //   selector.find('input[value="'+initialValue+'"]').prop('checked', true); 
    // }
  };

  function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
      if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
  }
  function linkOptionSelectors(avi, product) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        avi['root'] = avi['root'] || [];
        avi['root'].push(variant.option1);
        avi['root'] = unique(avi['root']);
        
        // Gathering values for the 2nd drop-down.
        if (variant.options.length > 1) {
          var key = variant.option1;
          avi[key] = avi[key] || [];
          avi[key].push(variant.option2);
          avi[key] = unique(avi[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (variant.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          avi[key] = avi[key] || [];
          avi[key].push(variant.option3);
          avi[key] = unique(avi[key]);
        }
      }
    }
  }

  var boxArray = [];
  function boxProduct(boxArray, form) {
  }
  
  function varaintSelect(form, _this, product) {
    var getVariantData = JSON.parse(form.find('[type="application/json"].v-data').text());
    var fieldsets = form.find('[data-option]').toArray();
    var options = [];

    $.each(fieldsets, function (i, v){ 
      var value = $(v).find("a.current").attr('data-value') || $(v).find("a.default").attr('data-value');
      options.push(value);
    });
    
    var currentVariant;

    $.each(getVariantData, function (i, variant){
      var lll = 0;
      $.each(variant.options, function (index, option){ 
        if(options[index] !== option){
          lll = 1;
        }
      });
      if(lll == 0){
        currentVariant = variant;
      }
    });

    if (!currentVariant) {
      // if (!addButton) {
      //   return;
      // }
    } else {
      if (_this.parent().attr('data-color') == 'yes' && currentVariant.featured_media != null) {
        form.find('.card__media').attr('data-current-image-id', currentVariant.featured_media.id);
        if ($('#collection-main-wrap').attr('data-product-img') == 'model') {
          var currentColor = form.find('[data-color="yes"] .product-card-color.current').attr('data-value') || form.find('[data-color="yes"] .product-card-color.default').attr('data-value');
          if (form.find('.card__media .product-card-media-img[data-model-alt="'+currentColor+' - Model"]').length) {
            var slideIndex = form.find('.card__media .product-card-media-img[data-model-alt="'+currentColor+' - Model"]').index();
            form.find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
          } else if (form.find('.card__media .product-card-media-img[data-model-alt="Model"]').length) {
            var slideIndex = form.find('.card__media .product-card-media-img[data-model-alt="Model"]').index();
            form.find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
          } else {
            var slideIndex = form.find('.product-card-media-img[data-image-id="'+currentVariant.featured_media.id+'"]').index();
            form.find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
          }
        } else if (form.find('.product-card-media-slider').length) {
          var slideIndex = form.find('.product-card-media-img[data-image-id="'+currentVariant.featured_media.id+'"]').index();
          form.find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
        } else if (form.find('.quick-view-media-slider').length) {
          var slideIndex = form.find('.quick-media-image[data-image-id="'+currentVariant.featured_media.id+'"]').index();
          form.find('.quick-view-media-slider')[0].swiper.slideTo(slideIndex, 0);
        }
      }
      if (form.find('[type="application/json"].variant-data').length) {
        var submitButton = form.find('[name="add"]')[0];
        var submitButtonText = form.find('[name="add"] .button-text')[0];
        var getVariantInventoryData = JSON.parse(form.find('[type="application/json"].variant-data').text());
        var preProp = form.find('.pre-prop')[0];
        if (!currentVariant.available) {
          submitButton.setAttribute('disabled', 'disabled');
          preProp.setAttribute('disabled', 'disabled');
          // submitButton.classList.remove('klaviyo-bis-trigger');
          submitButtonText.textContent = window.variantStrings.soldOut;
        } else {
          var variant_id = currentVariant.id;
          // if (notify_button[variant_id] == 'true') {
          //   submitButton.removeAttribute('disabled');
            // preProp.setAttribute('disabled', 'disabled');
          //   submitButton.classList.add('klaviyo-bis-trigger');
          //   submitButtonText.textContent = window.variantStrings.notifyButton;
          //   submitButtonText.parentElement.setAttribute('data-text', window.variantStrings.notifyButton);
          // } else {
            if (getVariantInventoryData[variant_id].varInvMng == 'shopify' && getVariantInventoryData[variant_id].varInvPlcy == 'continue' && getVariantInventoryData[variant_id].varInvQty <= 0 && getVariantInventoryData[variant_id].preorder_button == 'true' ) {
              submitButton.removeAttribute('disabled');
              preProp.removeAttribute('disabled');
              // submitButton.classList.remove('klaviyo-bis-trigger');
              submitButtonText.textContent = window.variantStrings.preOrder;
            } else {
              // submitButton.classList.remove('klaviyo-bis-trigger');
              submitButton.removeAttribute('disabled');
              preProp.setAttribute('disabled', 'disabled');
              submitButtonText.textContent = window.variantStrings.addToCart;
            }
          // }
        }
      }
      
      if (form.find('input[name="id"]').length) {
        var input = form.find('input[name="id"]');
        input.val(currentVariant.id).trigger('change');
      }
      if (form.find('[data-sku]').length) {
        form.find('[data-sku]').html(currentVariant.sku);
      }
      // console.log(currentVariant, 'currentVariant')

      if (_this.parent().attr('data-quick') == 'yes') {
        
      } else {
        if (_this.parent().attr('data-size') == 'yes' && currentVariant.available && fieldsets.length == form.find('[data-option] a.current').length) {
          if (_this.parent().attr('data-box') == 'yes') {
            if (!boxArray.includes(currentVariant.id)) {
              // form.addClass('disabled-card');
              // form.addClass('selected');
              boxArray.push(product.id+':'+currentVariant.id);
              // form.find('[name="add"]').trigger('click');
              // boxProduct(boxArray, form);
            }
          } else {
            form.find('[name="add"]').trigger('click');
          }
        }
      }
    }
  }
  $('body').on('click', '[data-option] a', function(e) {
    e.preventDefault();
    var form = $(this).parents('[data-card]')
    $(this).parent().find('a').removeClass('current');
    $(this).addClass('current');
    var avi = {};
    var product = JSON.parse(form.find('[type="application/json"].p-data').text());
    varaintSelect(form, $(this), product);
    linkOptionSelectors(avi, product);
    if ($(this).parent().attr('data-option-index') == 0) {
      updateOption(avi, form, 1);
      // updateOption(avi, form, 2);
    }
    if ($(this).parent().attr('data-option-index') == 1) {
      // updateOption(avi, form, 2);
    }
  });

  function varaintCapSelect(form, _this) {
    var getVariantData = JSON.parse(form.find('[type="application/json"].v-data').text());
    var fieldsets = form.find('[data-cap-option]').toArray();
    var options = [];

    $.each(fieldsets, function (i, v){ 
      var value = $(v).find("a.current").attr('data-value') || $(v).find("a.default").attr('data-value');
      options.push(value);
    });
    
    var currentVariant;

    $.each(getVariantData, function (i, variant){
      var lll = 0;
      $.each(variant.options, function (index, option){ 
        if(options[index] !== option){
          lll = 1;
        }
      });
      if(lll == 0){
        currentVariant = variant;
      }
    });

    if (!currentVariant) {
      // if (!addButton) {
      //   return;
      // }
    } else {
      if (_this.parent().attr('data-color') == 'yes' && currentVariant.featured_media != null) {
        var slideIndex = form.find('.cap-card-image[data-image-id="'+currentVariant.featured_media.id+'"]').index();
        form.find('#capsule-card-images')[0].swiper.slideTo(slideIndex, 0);
      }
    }
  }
  $('body').on('click', '[data-cap-option] a', function(e) {
    e.preventDefault();
    var form = $(this).parents('[data-card]')
    $(this).parent().find('a').removeClass('current');
    $(this).addClass('current');
    var avi = {};
    var product = JSON.parse(form.find('[type="application/json"].p-data').text());
    varaintCapSelect(form, $(this));
  });

  $('body').on('click', '[data-remove]', function(e) {
    e.preventDefault();
    var key = $(this).attr('data-variant-id');
    const cartUpdateUrl = '/cart/change.js';
    const requestData = {
      id: key,
      quantity: 0
    };
    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      if (document.querySelector('[data-box-collection]')) {
        var sectionId = document.querySelector('[data-box-collection]').getAttribute('data-section');
        fetchSection(sectionId)
      }
    })
    .then((cart) => {
      console.log('Item removed successfully:', cart);
    })
    .catch((error) => {
      console.error('Error removing item from cart:', error);
    });
    // boxProduct(boxArray);
  });

  $('body').on('click', '[data-change-product]', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    var handle = $(this).attr('data-handle');
    var url = '/products/'+handle+'?view=cap-box-grid';
    var _this = this;
    $.get(url, function(data) {
      var html = $(data).html();
      $('[data-show-product]').html(html);
      var capsule_featured_product_slider = new Swiper('#capsule-card-images' ,{
        slidesPerView: 1,
        spaceBetween: 5,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: '#capsule-card-images .swiper-button-next',
          prevEl: '#capsule-card-images .swiper-button-prev',
        },
        breakpoints: {
          990: {
            spaceBetween: 10,
          },
        }
      });
      $('[data-change-product]').removeClass('current');
      $(_this).addClass('current');
    })
  });

  $('body').on('click', '[data-checkout-cart]:not(.disabled)', function(e) {
    e.preventDefault();
    window.location.href = '/cart';
  });
  
  $('body').on('click', '[data-currency] a', function(e) {
    e.preventDefault();
    var val = $(this).attr('data-value');
    $('[name="country_code"]').val(val);
    $('#FooterCountryForm').submit();
  });

  $('body').on('click', '[data-language] a', function(e) {
    e.preventDefault();
    var val = $(this).attr('data-value');
    $('[name="locale_code"]').val(val);
    $('#FooterLanguageForm').submit();
  });
});
